import { matchRoutes } from '@umijs/max';
import 'lib-flexible';
import { requestConfig } from './requestConfig';

export function onRouteChange({ clientRoutes, location }: any) {
  const route = matchRoutes(clientRoutes, location.pathname)?.pop()?.route;
  console.log('route', route);
  // @ts-ignore
  document.title = route?.name || '';
}

// export async function render(oldRender: any) {
//   try {
//     await AppUtil.initAppInfo()
//   } catch (error) {
//     console.log(error)
//   }
//   oldRender()
// }
// export const qiankun = {
//   // 应用加载之前
//   async bootstrap(props: any) {
//     console.log('app1 bootstrap', props);
//   },
//   // 应用 render 之前触发
//   async mount(props: any) {
//     console.log('app1 mount', props);
//   },
//   // 应用卸载之后触发
//   async unmount(props: any) {
//     console.log('app1 unmount', props);
//   },
// };
export const request = requestConfig;
